'use strict';

export default (buttonDom) => {
    const button = {};

    button.registerOnClickHandler = (onClick) => {
        buttonDom.addEventListener('click', onClick);
    };

    button.hide = () => {
        if (!buttonDom.classList.contains('auction_cinema__button--hide')) {
            buttonDom.classList.add('auction_cinema__button--hide');
        }
    };

    button.show = () => {
        if (buttonDom.classList.contains('auction_cinema__button--hide')) {
            buttonDom.classList.remove('auction_cinema__button--hide');
        }
    };

    const getButtonOffsetTop = (imgHeight, isRedesign) => {
        const halfButtonHeight = 20;
        const paddingTop = 8;
        const half = ((imgHeight + paddingTop) / 2);
        return isRedesign ? half : half - halfButtonHeight;
    };

    button.initializeButtonPosition = (imgHeight, isRedesign) => {
        const newPos = getButtonOffsetTop(imgHeight, isRedesign);
        buttonDom.style.top = `${newPos}px`;
    };

    return button;
};